/** @format */

import apiSlice from './api-slice';

export const bookingConditionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBookingConditions: builder.query({
      query: (params) => ({
        url: `/booking/condition/list`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingCondition']
    }),

    getBookingCondition: builder.query({
      query: ({ id, ...params }) => ({
        url: `/booking/condition/${id}`,
        method: 'GET',
        params: params
      }),
      providesTags: ['BookingCondition']
    }),

    createBookingCondition: builder.mutation({
      query: (params) => ({
        url: '/booking/condition',
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['BookingCondition']
    }),
    startSearch: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/condition/${id}/startSearch`,
          method: 'PATCH',
          body: params
        };
      }
      // invalidatesTags: ['BookingCondition']
    }),
    updateBookingCondition: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/condition/${id}`,
          method: 'PATCH',
          body: params
        };
      },
      invalidatesTags: ['BookingCondition']
    }),

    updateWithoutEffectBookingCondition: builder.mutation({
      query: ({ id, ...params }) => {
        return {
          url: `/booking/condition/${id}`,
          method: 'PATCH',
          body: params
        };
      }
    }),

    updateBookingConditions: builder.mutation({
      query: (params) => {
        return {
          url: `/booking/condition/all`,
          method: 'PATCH',
          body: params
        };
      },
      invalidatesTags: ['BookingCondition']
    }),

    updateWithoutEffectBookingConditions: builder.mutation({
      query: (params) => {
        return {
          url: `/booking/condition/all`,
          method: 'PATCH',
          body: params
        };
      }
    }),
    deleteBookingCondition: builder.mutation({
      query: (id) => {
        return {
          url: `/booking/condition/${id}`,
          method: 'DELETE'
        };
      },
      invalidatesTags: ['BookingCondition']
    })
  })
});

export const {
  useGetBookingConditionsQuery,
  useGetBookingConditionQuery,
  useCreateBookingConditionMutation,
  useUpdateBookingConditionMutation,
  useUpdateBookingConditionsMutation,
  useUpdateWithoutEffectBookingConditionsMutation,
  useDeleteBookingConditionMutation,
  useStartSearchMutation
} = bookingConditionApi;
